<template>
	<div class="introduce">
		<div class="content">
			<div v-html="aboutDesc"></div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				aboutDesc:''
			}
		},
		mounted() {
			this.introduce()
		},
		methods: {
			introduce() {
				let vm = this
				this.axios.get('/api/company/introduce/findAll').then(res => {
					vm.aboutDesc = res.data.data.detail
				})
			}
		},
	}
</script>

<style scoped>
	.introduce{
		width: 1100px;
		min-height:600px;
		margin: 0 auto;
		overflow: hidden;
	}
	.introduce .content{
		margin-top: 20px;
		margin-bottom: 20px;
		width: 1100px;
		min-height:600px;
	}
</style>
